exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-1[data-v-fbaa94cc]{display:flex}@media (max-width:767px){.demo-1[data-v-fbaa94cc]{display:block}.demo-1>div[data-v-fbaa94cc]{margin-left:0;margin-top:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fbaa94cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/demo-1/demo-1.vue
// module id = 124
// module chunks = 0